var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('ScrollHelper'),_c('HomeBanner'),_c('div',{staticClass:"container-default"},[_c('BlueTokenChart')],1),_c('KnowMoreHome'),_c('div',{staticClass:"container-default"},[_c('HomeFaq'),_c('HomeTutorial')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }